import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {observer} from 'mobx-react'
import { observable, action, makeObservable } from 'mobx';

import {TodayTomorrowYesterday} from '../../../util/date/Formatters'

const WorkflowTaskDueDate = observer(class WorkflowTaskDueDate extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    due: PropTypes.string.isRequired
  };
  static isPastDue = (now, dueDate) => (now.startOf('day').add(1, 'day').isAfter(dueDate.startOf('day')));

  displayTooltip = false;
  toggleToolTip = () => this.displayTooltip = !this.displayTooltip;

  constructor(props) {
    super(props);

    makeObservable(this, {
      displayTooltip: observable,
      toggleToolTip: action
    });
  }

  render(){
    const { id, due } = this.props;
    const now = moment();
    let dueDisplay;
    const dueDate = moment(due);
    if(WorkflowTaskDueDate.isPastDue(now, moment(dueDate))){
      dueDisplay = (
        <span className="d-inline-flex align-items-center text-danger" >
          <i className="fas fa-exclamation-circle" />&nbsp;{TodayTomorrowYesterday(dueDate)}
        </span>
      );
    }else{
      dueDisplay = <span className="d-inline-flex align-items-center"><i className="far fa-clock" />&nbsp;{TodayTomorrowYesterday(dueDate)}</span>;
    }

    return dueDisplay;
  }
});

export default WorkflowTaskDueDate;
